import { useState, type ReactNode } from 'react';

interface Props {
  src: string;
  alt: string;
  className?: string;
  fallback: ReactNode;
  keepFallback?: boolean;
  loading?: 'eager' | 'lazy';
  style?: React.CSSProperties;
}

export default function ImageWithFallback({
  src, alt, className = '', fallback, keepFallback = false, loading = 'lazy', style,
}: Props) {
  const [errored, setErrored] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const showFallback = errored || (!loaded && keepFallback);

  return (
    <>
      {showFallback && fallback}
      {!errored && (
        <img
          src={src}
          alt={alt}
          loading={loading}
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={() => setErrored(true)}
          className={className}
          style={!loaded && keepFallback ? { ...style, opacity: 0 } : style}
        />
      )}
    </>
  );
}
